import { PasswordRequirement } from './form-input.types.ts';

export const passwordRequirements: PasswordRequirement[] = [
	{
		id: 'length',
		text: 'Şifren 6 rakamdan oluşmalı',
		validator: pass => pass.length >= 6
	},
	{
		id: 'unique',
		text: 'Tüm sayılar aynı olmamalı (Ör: 111111)',
		validator: pass => {
			if (pass.length === 0) return false;
			return !pass.split('').every(char => char === pass[0]);
		}
	},
	{
		id: 'sequential',
		text: 'Tüm sayılar ardışık olmamalı (Ör: 123456)',
		validator: pass => {
			if (pass.length < 6) return false;

			const forwardSequence = '0123456789';
			const backwardSequence = '9876543210';

			return !forwardSequence.includes(pass) && !backwardSequence.includes(pass);
		}
	}
];
